import { LanguageService } from "shared/services";

export class TextHelper {
    public static numberWithCommas(text) {
        return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, LanguageService.getTranslation('loc_comma'));
    }
}